import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SendMessage = gql`
  mutation SendMessage(
    $idempotencyId: IdempotencyToken!
    $input: SendCustomerChatMessageInput!
  ) {
    sendCustomerChatMessage(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on SendCustomerChatMessageSuccess {
        __typename
        chatMessage {
          __typename
          id
          sender
          eventType
          createdAt
          sessionId
        }
      }
      ... on SendCustomerChatMessageError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default SendMessage;
